import { forwardRef } from "react";
import { useCallback, useState } from "react";

import { observer } from "mobx-react";

import { BasicInput, BasicInputProps } from "../BasicInput";

export interface PasswordInputProps extends BasicInputProps {
  type: "password";
}

export const PasswordInput = observer(
  forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
    props,
    ref
  ) {
    const { type, ...rest } = props;

    const [plainPassword, setPlainPassword] = useState(false);

    const handleEyeClick = useCallback(() => {
      setPlainPassword((prev) => !prev);
    }, [setPlainPassword]);

    const eyeIcon = plainPassword ? "input-eye-open" : "input-eye-close";

    const passwordType = plainPassword ? "text" : type;

    return (
      <BasicInput
        ref={ref}
        type={passwordType}
        leftIcon="input-password"
        rightIcon={eyeIcon}
        {...rest}
        onRightIconClick={handleEyeClick}
      />
    );
  })
);
